import VueRouter from 'vue-router';
import Vue from 'vue'

import Home from './components/Home.vue'
import Post from './components/Post.vue'
import Newpost from './components/Newpost.vue'
import UpdatePost from './components/Updatepost.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: Home},
  { path: '/newpost', component: Newpost },
  { path: '/:title', component: Post },
  { path: '/updatepost/:title', component: UpdatePost },
  
];

const router = new VueRouter({
  routes
})

export default router;